import { Box } from '@otp/ui/src/box';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDeviceContext } from 'src/context/device.context';
import { MobileMenu } from './mobile-menu';
import { DesktopMenu } from './desktop-menu';

type LeftMenuProps = {
  isMenuOpen: boolean;
  onMenuToggle: () => void;
};

const collapsedWidth = 64;
const expandedWidth = 280;

export const LeftMenu = ({ isMenuOpen, onMenuToggle }: LeftMenuProps) => {
  const location = useLocation();
  const { isMobile } = useDeviceContext();

  useEffect(() => {
    if (isMenuOpen) {
      onMenuToggle();
    }
  }, [location]); // eslint-disable-next-line

  return (
    <Box sx={{ width: { sm: collapsedWidth }, flexShrink: { sm: 0 } }}>
      {isMobile && (
        <MobileMenu
          width={expandedWidth}
          isMenuOpen={isMenuOpen}
          onMenuToggle={onMenuToggle}
        />
      )}
      {!isMobile && (
        <DesktopMenu
          collapsedWidth={collapsedWidth}
          expandedWidth={expandedWidth}
        />
      )}
    </Box>
  );
};

export default LeftMenu;
